<template>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list dense>
      <slot />
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ContextMenu',
  data: () => ({
    showMenu: false,
    x: 0,
    y: 0,
  }),
  methods: {
    show(ev) {
      ev.preventDefault();
      this.close();
      this.x = ev.clientX;
      this.y = ev.clientY;
      this.$nextTick(
        () => {
          this.showMenu = true;
        },
      );
    },
    close() {
      this.showMenu = false;
    },
  },
};
</script>
